import React, { useState } from "react";

const Header = () => {
  const [dark, setDark] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleDarkToggle = () => {
    setDark(!dark);
    if (!dark) document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
  };

  return (
    <header className="fixed top-0 w-full bg-gray-50 dark:bg-gray-900 shadow z-50">
      <div className="container mx-auto flex justify-between items-center p-4">
        <a href="#hero" className="text-xl font-bold text-gray-800 dark:text-gray-100">
          Satwik.
        </a>
        <nav className={`flex gap-6 md:gap-4 items-center ${menuOpen ? "block" : "hidden md:flex"}`}>
          {["home", "workflow", "skills", "about", "projects", "contact"].map((section) => (
            <a
              key={section}
              href={`#${section}`}
              className="text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition"
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </a>
          ))}
          <button
            onClick={handleDarkToggle}
            className="ml-4 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
          >
            {dark ? "🌞" : "🌙"}
          </button>
        </nav>
        <button
          className="md:hidden text-gray-700 dark:text-gray-300 text-2xl"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
      </div>
    </header>
  );
};

export default Header;